// extracted by mini-css-extract-plugin
export default {"last_action_card_wrapper":"LastActionCard_last_action_card_wrapper__LmmIN","action":"LastActionCard_action__-m94o","action_card":"LastActionCard_action_card__tmv3s"};